import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import componentStyles from './Label.module.less';

const Label = ({ styles, message, link, target = '_self' }) => {
  const derivedStyles = { ...componentStyles, ...styles };
  return (
    <span className={derivedStyles.labelContent}>
      <FormattedMessage id={message} />
      {link && (
        <sup>
          {' '}
          <a className={derivedStyles.labelLink} href={link} target={target}>
            [?]
          </a>
        </sup>
      )}
    </span>
  );
};

Label.propTypes = {
  styles: PropTypes.shape({
    labelContent: PropTypes.string,
    labelLink: PropTypes.string,
  }),
  message: PropTypes.string.isRequired,
  link: PropTypes.string,
};

Label.defaultProps = {
  styles: {},
  link: null,
};

export default Label;
